import Vue from "vue";

import CommaInput from "@/components/CommaInput.vue";
import MonthPicker from "@/components/MonthPicker.vue";
import LinkInput from "@/components/LinkInput.vue";
import MaxLengthInput from "@/components/MaxLengthInput.vue";
import MaxLengthTextarea from "@/components/MaxLengthTextarea.vue";
import MaxLengthEditor from "@/components/MaxLengthEditor.vue";
import HyphenInput from "@/components/HyphenInput.vue";
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import RadioTypeCheck from "@/components/radio/RadioTypeCheck.vue";

Vue.component("CommaInput", CommaInput);
Vue.component("MonthPicker", MonthPicker);
Vue.component("MlInput", MaxLengthInput);
Vue.component("MlTextarea", MaxLengthTextarea);
Vue.component("MlEditor", MaxLengthEditor);
Vue.component("HyphenInput", HyphenInput);
Vue.component("PhotoUploadGridModule", PhotoUploadGridModule);
Vue.component("RadioTypeCheck", RadioTypeCheck);
Vue.component("LinkInput", LinkInput);
